<template>
  <div>
    <div :class="[preClass, 'container']">
      <base-table
       v-if="!smallScale"
        :data="addTaxData"
        title="*增值税"
      ></base-table>
      <base-table :data="incomTaxData" title="*企业所得税"></base-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      preClass: "tax-analyse",
      addTaxData: [],
      incomTaxData: []
    };
  },
  computed: {
    ...mapGetters(["currClient", "currDate", "smallScale",'currClientDetail'])
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$store.commit("app/SET_LOADING_STATUS", true);
      let params = {
        begin_date: this.currDate,
        end_date: this.currDate,
        report_type: 2
      };
      this.$axios
        .post("/report/boss-report/get-report", params)
        .then(res => {
          console.log("税金分析", res);
          let business_income_tax_id = this.currClientDetail.business_income_tax_id
          let value_added_tax_id = this.currClientDetail.value_added_tax_id
          if (res.success && res.rows) {
            let addArr = [];
            let incomeArr = [];

            res.rows.forEach(item => {
              item = {
                ...item,
                title: item.name,
                value: item.formula,
                filter: "toThousandFilter",
                align: "around"
              };
              if (item.key === 2105) {
                item.valueType = "tips";
                if (Number(item.value) > 0) {
                  item.tips = "账上有房屋，房产土地税要按期申报缴纳";
                  incomeArr.splice(incomeArr.length-2,0,item);
                }
                return;
              }
              if (item.key === 2106) {
                item.valueType = "tips";
                if (Number(item.value) > 0) {
                  item.tips = "本月产生收入，请关注合同当月是否及时缴纳印花税”";
                  incomeArr.push(item);
                }
                return;
              }
              if (item.key === 2107) {
                item.valueType = "tips";
                if (Number(item.value) > 0) {
                  item.tips =
                    "本月实收资本和资本公积金额有增加，请关注当月是否及时缴纳印花税”";
                  incomeArr.push(item);
                }
                return;
              }
              if (item.key_type === "增值税") {
                addArr.push(item);
                if( item.key===2003&&value_added_tax_id){
                   addArr.push({
                    // title: this.$dict[value_added_tax_id].name,
                    title:'企业增值税行业预警税负率',
                    value:  this.$dict[value_added_tax_id].comment,
                    align: "around"
                   });
                }
              } else if (item.key_type === "企业所得税") {
                incomeArr.push(item);
                if( item.key===2102&&business_income_tax_id){
                   incomeArr.push({
                    // title: this.$dict[business_income_tax_id].name,
                    title:'企业所得税行业预警税负率',
                    value:  this.$dict[business_income_tax_id].comment,
                    align: "around"
                   });
                }
              }
            });
            this.addTaxData = addArr;
            this.incomTaxData = incomeArr;
          }
        })
        .finally(_ => {
          this.$store.commit("app/SET_LOADING_STATUS", false);
        });
    }
  }
};
</script>

<style lang="less">
.tax-analyse {
  &-title {
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/financial-report/tax-analyse/index.vue